import { render, staticRenderFns } from "./MoleculeNotFoundCard.vue?vue&type=template&id=17812450&scoped=true&"
import script from "./MoleculeNotFoundCard.vue?vue&type=script&lang=js&"
export * from "./MoleculeNotFoundCard.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeNotFoundCard.vue?vue&type=style&index=0&id=17812450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17812450",
  null
  
)

export default component.exports